import React from 'react';
import { ArrowRight } from 'lucide-react';

const ServiceXOfferingsSection = ({ offeringsData = [], title = "ServiceNow Consulting", description }) => {
    return (
        <section className="w-full bg-[#FFFFFF] pb-16 lg:pb-24 relative mt-[20px] overflow-hidden text-left">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px] relative z-10">
                <div className="mb-[30px] lg:mb-[60px]">
                    <h2 className="text-[#01386A] font-sora text-[20px] lg:text-[30px] font-[600] text-left">
                        {title}
                    </h2>
                    {description && (
                        <p className="text-[#49577A] mt-2 text-left font-graphik text-[15px] sm:text-[16px] max-w-[850px]">
                            {description}
                        </p>
                    )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                    {offeringsData.map((item) => (
                        <div
                            key={item.id}
                            className="relative bg-[#F0F0F0] p-6 sm:p-8 min-h-[200px] flex flex-col justify-between overflow-hidden group transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
                        >
                            <div className="relative z-10">
                                <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora mb-2 leading-tight">
                                    {item.title}
                                </h3>

                                <p className="text-[#49577A] text-[14px] lg:text-[15px] font-graphik font-[500] leading-relaxed">
                                    {item.desc}
                                </p>
                            </div>

                            {item.products && item.products.length > 0 && (
                                <div className="relative z-10 pt-6 mt-6 border-t border-[#01386A]/10">
                                    <span className="font-graphik text-[11px] font-[600] text-[#777777] uppercase tracking-wider block mb-2.5">
                                        Related Products
                                    </span>
                                    <div className="flex flex-wrap items-center gap-2">
                                        {item.products.map((prod, idx) => (
                                            <span
                                                key={idx}
                                                className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-white border border-[#01386A]/15 text-[12px] font-[500] text-[#01386A] group-hover:border-[#EA6B24]/40 transition-colors duration-200"
                                            >
                                                <span>{prod}</span>
                                                <ArrowRight size={11} strokeWidth={2.5} />
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}

                            <div className="absolute bottom-0 right-0 w-[180px] h-[140px] pointer-events-none transition-transform duration-500 group-hover:scale-110 opacity-50 lg:opacity-100 z-0">
                                <img
                                    src="/assets/career/wrap1.svg"
                                    alt=""
                                    className="w-full h-full object-contain object-bottom-right"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServiceXOfferingsSection;